import React, { useEffect, useState, useCallback } from 'react';
import './BlogList.scss';
import TableComponent from "../../../components/TableComponent/TableComponent";
import ToastHelper from "../../../services/ToastHelper";
import { GET_BLOGS_LIST, PUBLISH_OR_UNPUBLISH_BLOG, DELETE_BLOG } from "../../../utils/apiPath";
import { postApi, deleteApi } from "../../../utils/apiServices";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Switch, message } from "antd"; // Added message import
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
export default function BlogList() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const fetchBlogs = useCallback(async () => {
    const payload = {
      pageIndex: pagination.current - 1,
      pageSize: pagination.pageSize,
      searchString: "",
      categoryId: null
    };
    
    setLoading(true);
    try {
      const res = await postApi(GET_BLOGS_LIST, payload);

      if (res?.data?.length !== 0) {
        setData(res?.data);
        setPagination(prev => ({ ...prev, total: res?.totalRecords }));
      } else {
        ToastHelper.error("No blogs found.");
      }
    } catch (err) {
      ToastHelper.error("Failed to fetch blogs. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [pagination.current, pagination.pageSize]); // Fixed dependency array

  useEffect(() => {
    fetchBlogs();
  }, [fetchBlogs]);

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handleEdit = (id) => {
    navigate(`/manage/Editblog/${id}`);
  };

  const showDeleteModal = (blogId) => {
    setBlogToDelete(blogId);
    setIsDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      
      const res = await deleteApi(`${DELETE_BLOG}?blogId=${blogToDelete}`);
      
      if (res?.statusCode === 200) {
        ToastHelper.success('Blog deleted successfully');
        fetchBlogs();
      } else {
        ToastHelper.error("Failed to delete blog");
      }
    } catch (err) {
      ToastHelper.error("Error deleting blog");
    } finally {
      setLoading(false);
      setIsDeleteModalOpen(false);
      setBlogToDelete(null);
    }
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setBlogToDelete(null);
  };

  const handleAdd = () => {
    navigate("/manage/addblog");
  };

  const handleSwitchPublishing = async (record) => {
    try {
      const { statusCode } = await postApi(
        `${PUBLISH_OR_UNPUBLISH_BLOG}?blogId=${record?.id}`,
        null
      );
      if (statusCode === 200) {
        fetchBlogs();
        message.success( // Now using the imported message
          `Blog ${record?.publishStatus ? "Unpublished" : "Published"} successfully`
        );
      }
    } catch (error) {
      message.error("Failed to update publish status");
    }
  };

  const columns = [
    {
      title: "Sl No",
      dataIndex: "blogId",
      sorter: false,
      render: (_, __, index) =>
        (pagination?.current - 1) * pagination?.pageSize + (index + 1),
    },
    {
      title: "Image",
      dataIndex: "media",
      sorter: false,
      render: (media) => (
        media?.url ? (
          <img 
            src={`${IMAGE_BASE_PATH}${media.url}`} 
            alt="Blog" 
            style={{ 
              maxWidth: '50px', 
              maxHeight: '50px',
              borderRadius: '4px',
              objectFit: 'cover'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : '-'
      ),
    },
    {
      title: "Title",
      dataIndex: "name",
      sorter: false,
    },
    {
      title: "Category",
      dataIndex: "blogCategoryName",
      sorter: false,
      render: (blogCategoryName) => blogCategoryName || "-",
    },
    {
      title: "URL",
      dataIndex: "urlName",
      sorter: false,
      width: 200,
      render: (url) => (
        <div className="url-cell">
          {url ? `https://yourdomain.com/blog/${url}` : "-"}
        </div>
      ),
    },
    {
      title: "Publish Status",
      dataIndex: "publishStatus",
      key: "publishStatus",
      render: (status, record) => (
        <Switch
          checked={status}
          checkedChildren="Published"
          unCheckedChildren="Unpublished"
          onChange={() => handleSwitchPublishing(record)}
        />
      ),
    },
    {
      title: "Published Date",
      dataIndex: "publishDate",
      sorter: false,
      render: (date) => date ? new Date(date).toLocaleDateString() : "-",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div className="action-buttons">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.id)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => showDeleteModal(record.id)}
          >
            Delete
          </Button>
        </div>
      ),
    },
];

  return (
    <div className="blogs">
      <div className="blogs_container">
        <div className="blogs_header">
          <div className="blogs_header_left">Blogs</div>
          <div className="blogs_header_right">
            <Button type="primary" onClick={handleAdd}>
              Add Blog
            </Button>
          </div>
        </div>
        <TableComponent
          columns={columns}
          data={data}
          pagination={pagination}
          loading={loading}
          onTableChange={handleTableChange}
        />
      </div>
      
      <Modal
        title="Confirm Delete"
        open={isDeleteModalOpen}
        onOk={handleDelete}
        onCancel={handleCloseDeleteModal}
        confirmLoading={loading}
      >
        <p>Are you sure you want to delete this blog?</p>
      </Modal>
    </div>
  );
}